import tokens from "../../tokens";

const themeHelper = {
  colors: {
    secondary: tokens.colors.secondary.light,
    primary: tokens.colors.primary.light,
    gray: tokens.colors.neutralLight.light,
    darkgray: tokens.colors.neutralMid.light,
    white: tokens.colors.bgCard.light,
  },
};

export default themeHelper;
